---
nb:
  downtime_events:
    auto_notice: Nedetidsperioder hensyntar ikke produksjonsoptimalisering for kraftverk med magasin
    available: Tilgjengelig
    capacity_impact: Kapasitetspåvirkning
    chart_monthly_heading: Nedetidskategorisering (år)
    chart_volume_heading: Produksjon og nedetid
    chart_yearly_heading: Nedetidskategorisering (år)
    components:
      control_system: Kontrollsystem
      external_grid: Eksternt nett
      fiber_and_communication: Fiber og kommunikasjon
      foundation: Fundament
      generator: Generator
      hardstand: Hardstand
      high_voltage_system: Høyspent
      intake: Inntak
      internal_grid: Internt nett
      inverter: Inverter
      logger: Logger
      module: Modul
      other: Annet
      pyranometer: Pyranometer
      road: Rute
      string: Streng
      substation: Transformatorstasjon
      transformer: Transformator
      turbine: Turbin
      waterway: Vannvei
    create: Opprett
    deletion_failed: Kunne ikke slette nedetidsperiode
    downtime_event: Nedetidsperioder
    edit: Rediger nedetidsperiode
    email:
      body:
        contact: Kontakt %{name} for mer informasjon
        info: En ny nedetidsperiode er planlagt. Vennligst ta hensyn til dette i driften av dette kraftverket.
    email_to_operator: Send e-post til operatøren
    est_downtime_cost: Est. nedetidskostnad
    est_downtime_hours: Est. nedetidstimer
    est_loss: Est. tap
    est_lost_prod_vol: Est. volumtap
    est_revenue: Est. inntekter
    est_vol_hr: Est. vol/time
    filter_out_no_water: Filtrer ut ikke vann
    model_name: Nedetidsperiode
    model_name_plural: Nedetidsperioder
    model_name_short: Nedetid
    no-data-text: Ingen data tilgjengelig - velg et kraftverk
    no_hours: Timer berørt
    no_match: Valgte parametere samsvarer ikke med noen kraftverk.
    not_specified: Ikke spesifisert
    reasons:
      commercial_price: Kommersielt/Pris
      effect_restriction: Effektrestriksjon
      external_grid: Eksternt Nett
      grid: Nett
      no_water: Lav vannstand
      operational_loss: Operasjonelt tap
      overflow: Overløp
      planned_maintenance: Planlagt vedlikehold
      reservoir: Reservoar
      technical: Teknisk
      uncategorized: Ukategorisert
      unplanned_maintenance: Uplanlagt vedlikehold
      water_loss: Vann tap
      wind: Vind
    scheduled_downtime_event: Planlagt nedetid
    scheduled_downtime_events_name: Planleggingsperioder
    scheduled_downtime_for: Planleggingsperiode for
    see_stats: Velg et kraftverk for å se statistikk
    tab_downtime: Nedetidshendelser
    tab_environmental_flow: Minstevannføringshendelser
    tech_downtime: Teknisk nedetid
    tech_downtime_short: Tek. nedetid
    unavailable: Utilgjengelig
    verified_event_cannot_be_deleted: Verifiserte nedetidsperioder kan ikke slettes
    verified_event_change_confirmation: Denne nedetidsperioden har blitt verifisert. Endringer kan påvirke rapporter og beregninger. Vil du fortsette?
    water_level: Vannstand
    water_level_unit: moh
    water_loss_downtime: Vanntap nedetid
  environmental_flow:
    actions: Handlinger
    assign_to: Tildel til
    avg_flow: Gj.snitt vannføring
    avg_violation: Gj.snitt brudd
    comment: Beskrivelse
    confirm_delete: Er du sikker på at du vil slette denne minstevannføringshendelsen?
    confirm_run_detection: Kjør brudddeteksjon for de siste 30 dagene? Dette kan ta noen minutter.
    corrective_volume: Volum (l/s) for korrigerende tiltak
    create_event: Opprett minstevannføringshendelse
    current_image: Nåværende bilde
    delete_error: Kunne ikke slette hendelse. Verifiserte hendelser kan ikke slettes.
    detection_job_error: Kunne ikke starte brudddeteksjonsjobb. Vennligst prøv igjen.
    detection_job_started: Brudddeteksjonsjobb startet. Resultater vises snart.
    duration: Varighet
    ends_at: Sluttid
    event: minstevannføringshendelse
    event_created: Minstevannføringshendelse opprettet
    excluded: Ekskludert
    fetch_data_error: Kunne ikke laste data for minstevannføring. Vennligst prøv igjen.
    fetch_drilldown_error: Kunne ikke laste drilldown-data. Vennligst prøv igjen.
    fetch_error: Kunne ikke laste minstevannføringshendelser. Vennligst prøv igjen.
    fetch_events_error: Kunne ikke laste minstevannføringshendelser. Vennligst prøv igjen.
    fetch_latest_value_error: Kunne ikke laste siste sensorverdi. Vennligst prøv igjen.
    fetch_threshold_error: Kunne ikke laste grensedata. Vennligst prøv igjen.
    further_corrective_measures: Videre korrigerende tiltak
    generate_task: Generer oppgave
    hide_excluded: Skjul ekskluderte
    image: Bilde
    immediate_measures: Umiddelbare tiltak
    linked_task: Koblet oppgave
    min_flow: Min vannføring
    no_responsibles_available: Ingen ansvarlige tilgjengelig. Vennligst konfigurer minst én selskapsansvarlig for dette kraftverket.
    power_plant: Kraftverk
    reporter_name: Navn på reporter
    run_detection: Detekter brudd
    show_excluded: Vis ekskluderte
    starts_at: Starttid
    threshold: Grense
    title: Minstevannføringsbrudd
    total_events: Totalt antall hendelser
    total_hours: Totalt antall timer
    update_comment_error: Kunne ikke oppdatere beskrivelse. Vennligst prøv igjen.
    update_excluded_error: Kunne ikke oppdatere ekskluderingsstatus. Vennligst prøv igjen.
    update_further_corrective_measures_error: Kunne ikke oppdatere videre korrigerende tiltak. Vennligst prøv igjen.
    update_immediate_measures_error: Kunne ikke oppdatere umiddelbare tiltak. Vennligst prøv igjen.
    update_reporter_name_error: Kunne ikke oppdatere navn på reporter. Vennligst prøv igjen.
    update_verification_error: Kunne ikke oppdatere verifiseringsstatus. Vennligst prøv igjen.
    verified: Verifisert
    view_image: Se bilde
    violation_pct: Brudd %
